const config = {
    build_number: '616292',
    build_timestamp: '2026-09-23T18:42:37.698Z',
    build_commit: 'd705ab9d1b72a745a759ec2f4a248417f2b10d6e',
};

// locally, the build number is always 4122 (which allows us to load non-English content locally)
if (Number.isNaN(parseInt(config.build_number, 10))) {
    config.build_number = '4122';
}

export default config;
